"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zRecordOfflineAcceptanceRequest = exports.zAcceptLegalRequest = exports.LEGAL_ACCEPTANCE_METHODS = exports.zLegalDocumentId = exports.LEGAL_DOCUMENT_IDS = void 0;
const zod_1 = require("zod");
/** Mirrors the ids in bay2bill-web-ops/legal/manifest.json. */
exports.LEGAL_DOCUMENT_IDS = [
    "terms-of-service",
    "privacy-policy",
    "data-processing-agreement",
    "refund-policy",
    "copyright-policy",
];
exports.zLegalDocumentId = zod_1.z.enum(exports.LEGAL_DOCUMENT_IDS);
exports.LEGAL_ACCEPTANCE_METHODS = ["login_clickwrap", "signup", "offline"];
exports.zAcceptLegalRequest = zod_1.z.object({
    documents: zod_1.z
        .array(zod_1.z.object({ id: exports.zLegalDocumentId, version: zod_1.z.string().min(1) }))
        .min(1),
});
exports.zRecordOfflineAcceptanceRequest = zod_1.z.object({
    userId: zod_1.z.number().int().positive(),
    documents: zod_1.z.array(exports.zLegalDocumentId).min(1),
    note: zod_1.z.string().trim().min(1).max(500),
});
//# sourceMappingURL=legal.js.map